const UNIT_TEST_REGEXP = /^localhost$/
const hostname = typeof window !== 'undefined' && window.location.hostname
const isUnitTest = hostname && hostname.match(UNIT_TEST_REGEXP)
let currentEnv

/**
 * Utility to get, set and check the current environment.
 */

/**
 * The environments we support.
 *
 * @static
 * @property ENVS
 */
export const ENVS = {
  DEVELOPMENT: 'development',
  PRODUCTION: 'production',
  TEST: 'test',
}

// =============================== Private ================================ //

/**
 * @private
 * @method ensureValidEnv
 *
 * @param envName {String} The environment name
 *
 * @throws {Error} If the environment not valid.
 */
function ensureValidEnv(envName) {
  if (!Object.keys(env.ENVS).some(name => env.ENVS[name] === envName)) {
    throw new Error('"' + envName + '" is not valid environment.')
  }
}

// ============================== Public API ============================== //

/**
 * @method get
 * @return {String} The current environment.
 */
function get() {
  return currentEnv
}

/**
 * Sets the current environment. The environment must be defined in env.ENVS.
 *
 * @method set
 *
 * @param envName {String} The environment name
 */
function set(envName) {
  ensureValidEnv(envName)
  currentEnv = envName
}

/**
 * @method is
 *
 * @param envName {String} The environment name
 *
 * @return {Boolean} Whether this environment is the current one.
 */
function is(envName) {
  return get() === envName
}

// =============================== API setup =============================== //

// Exposes the public API
export const env = {
  get,
  set,
  is,

  isDevelopment() {
    return is(ENVS.DEVELOPMENT)
  },
  isProduction() {
    return is(ENVS.PRODUCTION)
  },
  isTest() {
    return is(ENVS.TEST)
  },

  ENVS,

  /**
   * The default environment when not specified.
   *
   * @static
   * @property DEFAULT_ENV
   * @type {String}
   */
  DEFAULT_ENV: ENVS.DEVELOPMENT,
}

// Set the current environment. During build, NODE_ENV may be undefined, in which case we set to default environment.
// In a browser environment, NODE_ENV is hardcoded to the build environment (either development or production).
set(process.env.NODE_ENV || env.DEFAULT_ENV)

// The unit test run in a browser environment, but we don't want to track as development.
// @todo Set unit test environment in CI
if (isUnitTest) {
  set(ENVS.TEST)
}
